// src/store/auth.js
import { create } from 'zustand';
import { AdminAPI } from '../api/admin';

function readToken() {
  try { return localStorage.getItem('adminToken') || ''; } catch { return ''; }
}

export const useAuth = create((set, get) => ({
  token: readToken(),
  user: null,
  booted: false,

  isAuthed: () => !!get().token,

  async boot() {
    const token = readToken();
    if (!token) {
      set({ token: '', user: null, booted: true });
      return { ok: false };
    }
    try {
      const data = await AdminAPI.me();
      const user = data?.user || null;
      // Берём токен заново из localStorage — он мог обновиться при refresh
      const fresh = readToken();
      set({ token: fresh, user, booted: true });
      return { ok: true, user };
    } catch (e) {
      try { localStorage.removeItem('adminToken'); } catch {}
      set({ token: '', user: null, booted: true });
      return { ok: false, error: e.message };
    }
  },

  async login(username, password) {
    try {
      const resp = await AdminAPI.login(username, password);
      
      const token = resp?.token || '';
      const userFromLogin = resp?.user || null;
      const refresh = resp?.refresh;

      if (!token) {
        throw new Error('Empty token');
      }
      
      try { localStorage.setItem('adminToken', token); } catch {}
      if (refresh) { try { localStorage.setItem('adminRefresh', refresh); } catch {} }

      // СРАЗУ дёрнем /auth/me для валидации и чтобы он «появился» в сети
      let user = userFromLogin;
      try {
        const me = await AdminAPI.me(); // придёт { user }
        user = me?.user || userFromLogin;
      } catch (meError) { 
        /* не страшно, есть данные из /login */ 
      }

      set({ token, user, booted: true });
      const result = { ok: true, token, user };
      return result;
    } catch (e) {
      try { localStorage.removeItem('adminToken'); } catch {}
      set({ token: '', user: null, booted: true });
      return { ok: false, error: e.message || 'Login failed' };
    }
  },

  logout() {
    try { localStorage.removeItem('adminToken'); } catch {}
    try { localStorage.removeItem('adminRefresh'); } catch {}
    set({ token: '', user: null, booted: true });
  },
}));
